enum RestaurantPreference {
  Like = "like",
  Neutral = "neutral",
  Dislike = "dislike",
}

export default RestaurantPreference;
